module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Member List",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "User Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.username),
      callback: function($$v) {
        _vm.$set(_vm.filters, "username", $$v)
      },
      expression: "filters.username"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorMembers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": _vm.getDoctorMembers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": "Active"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "Limited"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Blocked"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.memberList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleId",
      "label": "role"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleId == '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Nurse")]) : _vm._e(), _vm._v(" "), (scope.row.roleId == '3') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Wareshoue Admin")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alias",
      "label": "Alias"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "Phone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatMemberStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditMember(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.membersTotalPage
    },
    on: {
      "current-change": _vm.handleMembersPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Groups",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Group Name",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.groupCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "groupCondition", $$v)
      },
      expression: "filters.groupCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getGroupList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddGroup
    }
  }, [_vm._v("Add Group")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondLoading),
      expression: "secondLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.groups,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Users"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.userList), function(user, index) {
          return _c('el-tag', {
            key: index,
            attrs: {
              "type": "success",
              "disable-transitions": ""
            }
          }, [_vm._v(_vm._s(user.username) + "\n                        ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGroup(scope.row.groupNo)
            }
          }
        }, [_vm._v("Delete\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.groupTotalPage
    },
    on: {
      "current-change": _vm.handleGroupPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Invitations",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.invitationEmail),
      callback: function($$v) {
        _vm.$set(_vm.filters, "invitationEmail", $$v)
      },
      expression: "filters.invitationEmail"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInvitations
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.invitationVisible = true
      }
    }
  }, [_vm._v("Invitation")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdLoading),
      expression: "thirdLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.invitations
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invitationNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "Role"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "DateTime",
      "formatter": _vm.formatTimesTamp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "formatter": _vm.formatRole
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.invitationTotalPage
    },
    on: {
      "current-change": _vm.handleInvitationPageChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Member",
      "width": "80%",
      "visible": _vm.editMemberVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editMemberVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.editMemberObj,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UserName",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editMemberObj.userName),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "userName", $$v)
      },
      expression: "editMemberObj.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editMemberObj.status),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "status", $$v)
      },
      expression: "editMemberObj.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("Limited")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("Blocked")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editMemberObj.alias),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "alias", $$v)
      },
      expression: "editMemberObj.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editMemberObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingTransaction", $$v)
      },
      expression: "editMemberObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "pendingAmount", $$v)
      },
      expression: "editMemberObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editMemberObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editMemberObj, "minPayment", $$v)
      },
      expression: "editMemberObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editMemberVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMember($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Group",
      "width": "80%",
      "visible": _vm.addGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "group",
    attrs: {
      "model": _vm.group,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.group.groupName),
      callback: function($$v) {
        _vm.$set(_vm.group, "groupName", $$v)
      },
      expression: "group.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.group.users),
      callback: function($$v) {
        _vm.$set(_vm.group, "users", $$v)
      },
      expression: "group.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingTransaction", $$v)
      },
      expression: "group.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.group, "pendingAmount", $$v)
      },
      expression: "group.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.group.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.group, "minPayment", $$v)
      },
      expression: "group.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addGroup($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Group",
      "width": "80%",
      "visible": _vm.editGroupVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editGroupVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editGroupObj",
    attrs: {
      "model": _vm.editGroupObj,
      "label-width": "220px",
      "rules": _vm.groupFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editGroupObj.groupName),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "groupName", $$v)
      },
      expression: "editGroupObj.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editGroupObj.users),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "users", $$v)
      },
      expression: "editGroupObj.users"
    }
  }, _vm._l((_vm.nurseList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.username,
        "value": user.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending transactions"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingTransaction),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingTransaction", $$v)
      },
      expression: "editGroupObj.pendingTransaction"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payment Pending amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.pendingAmount),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "pendingAmount", $$v)
      },
      expression: "editGroupObj.pendingAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimum Payment"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editGroupObj.minPayment),
      callback: function($$v) {
        _vm.$set(_vm.editGroupObj, "minPayment", $$v)
      },
      expression: "editGroupObj.minPayment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editGroupVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGroup($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Invitation",
      "width": "80%",
      "visible": _vm.invitationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.invitationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "invitation",
    attrs: {
      "model": _vm.invitation,
      "label-width": "220px",
      "rules": _vm.invitationRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.invitation.role),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "role", $$v)
      },
      expression: "invitation.role"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "2",
      "label": "Nurse"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "Warehouse Admin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.invitation.email),
      callback: function($$v) {
        _vm.$set(_vm.invitation, "email", $$v)
      },
      expression: "invitation.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.invitationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.invitationRegister($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a2a4e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/teams.vue
// module id = 785
// module chunks = 1